<template>
    <div>
        <p>Leerlingen kunnen zich aanmelden bij deze klas door de volgende <strong>uitnodigingscode</strong> in te voeren op <a :href="'//'+registerLink">{{ registerLink }}</a>:</p>
        <h1 class="invite-code">{{ group.code }}</h1>
        <p class="note note--info"><strong>Let op:</strong> deze code is hoofdlettergevoelig.</p>
        <p class="note note--info">Wijs de leerlingen erop dat ze hun <strong>e-mailadres goed invullen</strong>, anders kunnen ze zich niet registreren!</p>

        <div v-transfer-dom="'modal__footer'" class="action-wrapper">
            <a :href="inviteUrl" class="tag button-timid button-forward" >Voorbeeld uitnodigingsmail</a>
            <primary-button @clicked="done" v-if="isCreating" >Klaar</primary-button>
        </div>

    </div>
</template>


<script>
import notify from 'js/components/notifications/notificationsMixin'
import validation from 'js/components/auth/validationMixin'

import PrimaryButton from 'js/components/elements/PrimaryButton.vue'

export default {
    name: 'GroupSettingsInvite',
    mixins: [ notify, validation ],
    components: { PrimaryButton },
    props: {
        group: {
            required: true,
        },
        school: {},
        isCreating: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        registerLink: function() {
            return document.location.host + '/registreren'
        },

        exampleInvite: function() {
            return {
                title: 'Aanmelden bij Kiempunt',
                body: 'Hallo!\n\nVoor het vak beeldende vorming gaan we de komende tijd gebruikmaken van Kiempunt. In deze app krijg je een eigen werkmap waarin jouw gemaakte werken komen te staan.\n\nJe kunt alvast een nieuwe werkmap aanmaken door naar ' + this.registerLink + ' te gaan.\n\n Bij \'Uitnodigingscode\' vul je dan de code  ' + this.group.code + '  in. Zo kom je direct bij jouw klas ' + this.group.name + '.\n\n\nVeel succes!'
            }
        },

        inviteUrl: function() {
            return 'mailto:?subject=' + encodeURIComponent(this.exampleInvite.title) + '&body=' + encodeURIComponent(this.exampleInvite.body)
        },
    },

    methods: {
        done: function(e) {
            e.preventDefault()
            this.$emit('done')
        },
        save: function() {
            return Promise.resolve()
        }
    }
}
</script>


<style lang="scss">

    @import 'global';

    .invite-code {
        font-family: $font-body;
        text-align: center;
    }

</style>



// WEBPACK FOOTER //
// Invite.vue?52587728